import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.PostingAccount.Delete.IRequest;
type Response = Api.Core.PostingAccount.Delete.IResponse;
type Headers = Api.Core.PostingAccount.Delete.IHeaders;
const url = '/api/Finance/LedgerAccount/:id';
export default async function postingAccountDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
